import { render } from "./RequestRegistered.vue?vue&type=template&id=5cfa4e58&scoped=true"
import script from "./RequestRegistered.vue?vue&type=script&lang=js"
export * from "./RequestRegistered.vue?vue&type=script&lang=js"

import "./RequestRegistered.vue?vue&type=style&index=0&id=5cfa4e58&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5cfa4e58"

export default script